import React, { Component, PropTypes } from 'react';
import classnames from 'classnames';

export default class AccordionTable extends Component {
  constructor(props) {
    super(props);
  }

  toggle = (event) => {
    // Need loop to close all panels
    var acc = document.getElementsByClassName("accordion");
    var i;

    event.currentTarget.classList.toggle('active');

    // reset all panels to closed
    for (i = 0; i < acc.length; i++) {
        var panel = acc[i].nextElementSibling;
        panel.style.display = 'none';

        // set all carets to download
        var caretReset = acc[i].getElementsByTagName("i");

        caretReset[0].classList.remove('fa-chevron-up');
        caretReset[0].classList.add('fa-chevron-down');

        // get rid of any stale active classes
        if (event.currentTarget !== acc[i]) {
          // remove active class
          acc[i].classList.remove('active')
        }
    }


    // get caret class
    var caret = event.currentTarget.getElementsByTagName("i")

    // if the currentTarget is not active show it
    if (event.currentTarget.classList.contains('active')) {
      // get panel beneath button and show
      event.currentTarget.nextElementSibling.style.display = 'block';

      // update caret class
      caret[0].classList.remove('fa-chevron-down');
      caret[0].classList.add('fa-chevron-up');
    } else {
      // get panel beneath button and hide
      event.currentTarget.nextElementSibling.style.display = 'none';

      // update caret class
      caret[0].classList.remove('fa-chevron-up');
      caret[0].classList.add('fa-chevron-down');
    }

    // scrollTo anchor tag of hot header!
    var sectionHead = event.currentTarget;
    var topPos = this.getElOffset(sectionHead);
    window.scrollTo(0, topPos);

  }

  getElOffset = (el) => {
    var rect = el.getBoundingClientRect();
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var elTop = rect.top + scrollTop;

    return elTop;
  }

  render() {

    return (

      <div className="applyToListLP-accordionWrapper">




        <button onClick={this.toggle} className="accordion">
          <div className="headerWrapper">
            <h5>Basic </h5><h6>$120/year</h6>
          </div>
          <i className="fa fa-chevron-down fa-2x"></i>
        </button>

        <div className="panel">
          <div className="panel-innerWrapper">
            <div className="lft-col">
              <p>Page listing</p>
            </div>
            <div className="rt-col">
              <p><i className="fa fa-check" aria-hidden="true"></i></p>
            </div>
          </div>

          <div className="panel-innerWrapper">
            <div className="lft-col">
              <p>WWW Badge</p>
            </div>
            <div className="rt-col">
              <p><i className="fa fa-check" aria-hidden="true"></i></p>
            </div>
          </div>

          <div className="panel-innerWrapper">
            <div className="lft-col">
              <p>Social Media mention to 95k+</p>
            </div>
            <div className="rt-col">
              <p><i className="fa fa-check" aria-hidden="true"></i></p>
              <p>2x/year</p>
            </div>
          </div>

          <div className="panel-innerWrapper">
            <div className="lft-col">
              <p>Email newsletter highlight to 25k+</p>
            </div>
            <div className="rt-col">
              <p><i className="fa fa-check" aria-hidden="true"></i></p>
              <p>2x/year</p>
            </div>
          </div>

          <div className="panel-innerWrapper">
            <div className="lft-col">
              <p>Event / product highlight in newsletter & social media </p>
            </div>
            <div className="rt-col">
              <p>2x/year</p>
            </div>
          </div>

          <div className="panel-innerWrapper">
            <div className="lft-col">
              <p>Story/video of your org on WWW homepage & social media</p>
            </div>
            <div className="rt-col">
              <p>&nbsp;</p>
            </div>
          </div>

          <div className="panel-innerWrapper">
            <div className="lft-col">
              <p>Ad placement in newsletters</p>
            </div>
            <div className="rt-col">
              <p>&nbsp;</p>
            </div>
          </div>

          <div className="panel-innerWrapper panel-innerWrapper-last">
            <div className="lft-col">
              <p>Website banner ad </p>
            </div>
            <div className="rt-col">
              <p>&nbsp;</p>
            </div>
          </div>

        </div>



        <button onClick={this.toggle} className="accordion">
          <div className="headerWrapper">
            <h5>For-Profit Premium </h5><h6>$240/year</h6>
          </div>
          <i className="fa fa-chevron-down fa-2x"></i>
        </button>

        <div className="panel">

          <div className="panel-innerWrapper">
            <div className="lft-col">
              <p>Page listing</p>
            </div>
            <div className="rt-col">
              <p><i className="fa fa-check" aria-hidden="true"></i></p>
            </div>
          </div>

          <div className="panel-innerWrapper">
            <div className="lft-col">
              <p>WWW Badge</p>
            </div>
            <div className="rt-col">
              <p><i className="fa fa-check" aria-hidden="true"></i></p>
            </div>
          </div>

          <div className="panel-innerWrapper">
            <div className="lft-col">
              <p>Social Media mention to 95k+</p>
            </div>
            <div className="rt-col">
              <p><i className="fa fa-check" aria-hidden="true"></i></p>
              <p>3x/year</p>
            </div>
          </div>

          <div className="panel-innerWrapper">
            <div className="lft-col">
              <p>Event/product highlight in email newsletter & social media</p>
            </div>
            <div className="rt-col">
              <p><i className="fa fa-check" aria-hidden="true"></i></p>
              <p>4x/year</p>
            </div>
          </div>

          <div className="panel-innerWrapper">
            <div className="lft-col">
              <p>Story/video of your org on WWW homepage & social media</p>
            </div>
            <div className="rt-col">
              <p><i className="fa fa-check" aria-hidden="true"></i></p>
              <p>2x/year</p>
            </div>
          </div>

          <div className="panel-innerWrapper">
            <div className="lft-col">
              <p>Ad placement in newsletters</p>
            </div>
            <div className="rt-col">
              <p><i className="fa fa-check" aria-hidden="true"></i></p>
              <p>2x/year</p>
            </div>
          </div>

          <div className="panel-innerWrapper panel-innerWrapper-last">
            <div className="lft-col">
              <p>Website banner ad </p>
            </div>
            <div className="rt-col">
              <p><i className="fa fa-check" aria-hidden="true"></i></p>
              <p>1x/year</p>
            </div>
          </div>

        </div>


      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/applyForBuyFromWomen/AccordionTable.jsx